@use "../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../styles/Constants.scss" as Constants;

$border: solid 1px Colors.$col-lighterGrey;

.SyncDiff {
	flex: 1;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	justify-content: space-evenly;

	.diffColumn {
		flex: 1;
		display: flex;
		flex-direction: column;

		.title {
			font-size: Constants.$val-fontSizeRegular;
			line-height: Constants.$val-lineHeightRegular;
			padding: Constants.$val-spacing-s Constants.$val-spacing-m;
			border-bottom: $border;
			font-weight: 500;
			text-transform: uppercase;
		}

		.list {
			flex: 1;
			overflow-y: auto;
			padding: Constants.$val-spacing-s;
		}

		.listEmpty {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			flex: 1;

			.emptyDescription {
				font-size: Constants.$val-fontSizeBig;
				line-height: Constants.$val-lineHeightBig;
				color: Colors.$col-design-grey10;
			}
		}

		.counter {
			font-size: Constants.$val-fontSizeRegular;
			line-height: Constants.$val-lineHeightRegular;
			border-top: $border;
			padding: Constants.$val-spacing-s Constants.$val-spacing-m;
			text-align: right;
		}

		&:last-child {
			border-left: $border;
		}
	}

	.materialEntry {
		padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	}
}
